import { SmartEventCondition } from 'constants/enums';

export const isCompareCondition = (condition: SmartEventCondition) =>
  condition !== SmartEventCondition.INCREASE &&
  condition !== SmartEventCondition.DECREASE &&
  condition !== SmartEventCondition.INCREASE_FROM_REF &&
  condition !== SmartEventCondition.DECREASE_FROM_REF &&
  condition !== SmartEventCondition.INCREASE_OVER_TIME &&
  condition !== SmartEventCondition.DECREASE_OVER_TIME &&
  condition !== SmartEventCondition.REACH_DATE &&
  condition !== SmartEventCondition.RECURRING_DATE &&
  condition !== SmartEventCondition.BASELINE_RISE &&
  condition !== SmartEventCondition.BASELINE_DROP &&
  condition !== SmartEventCondition.BASELINE_ANY;
